<script lang="ts">
  import { cn } from '$lib/utils';

  export let className = 'w-6 h-6';
</script>

<img
  src="/brand/icon-white-bg-black.svg"
  class={cn(className, 'hidden dark:block')}
  alt="techlockdown logo"
/>
<img
  src="/brand/icon-color-bg-transparent.svg"
  class={cn(className, 'dark:hidden')}
  alt="techlockdown logo"
/>
